import { Key } from "react";

export const MergeCustomerView = ({changes}: {changes: Record<string, any>}) => {
  const isClosedAtMerge = 'closedAt' in changes;

  if (isClosedAtMerge) {
    const mergedData = changes.mergedInto?.newValue || {};

    return (
      <table>
        <thead>
        <tr>
          <th>Merged to CIF Number</th>
          <th>Name</th>
          <th>Mother Branch</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{mergedData.customerNumber || <strong>None</strong>}</td>
          <td>{mergedData.effectiveName || <strong>None</strong>}</td>
          <td>{mergedData.branchName || <strong>None</strong>}</td>
        </tr>
        </tbody>
      </table>
    );
  }

  const previousRows = Array.isArray(changes.mergedCustomers?.previousValue)
    ? changes.mergedCustomers.previousValue
    : [];

  const newRows = Array.isArray(changes.mergedCustomers?.newValue) ? changes.mergedCustomers.newValue : [];

  const allRows = newRows.filter((nr: { customerNumber: string; }) => !previousRows.some((pr: { customerNumber: string; }) => nr.customerNumber === pr.customerNumber));

  return (
    <table>
      <thead>
      <tr>
        <th>Merged CIF Number</th>
        <th>Name</th>
        <th>Mother Branch</th>
        <th>Status</th>
      </tr>
      </thead>
      <tbody>
      {allRows.map((row: {customerNumber: string; effectiveName: string; branchName: string; status: string;}, index: Key | null | undefined) => (
          <tr key={index}>
            <td>{row.customerNumber || <strong>None</strong>}</td>
            <td>{row.effectiveName || <strong>None</strong>}</td>
            <td>{row.branchName || <strong>None</strong>}</td>
            <td>{row.status   || <strong>None</strong>}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
